<template>
  <el-dialog
    v-bind="dialogOption"
    :visible.sync="show"
    :class="b()"
    :close-on-click-modal="false"
    :before-close="() => cancel()"
    append-to-body
    v-on="listeners"
    @open="onOpen"
  >
    <el-form
      ref="form"
      v-loading="loading"
      label-position="top"
      :model="vo"
      :rules="rules"
    >
      <el-form-item
        prop="formControlId"
        :label="$t('project.issueType.customFieldDialog.form.label.type')"
      >
        <el-select
          v-model="vo.formControlId"
          :disabled="isUpdate"
          :placeholder="
            $t('project.issueType.customFieldDialog.form.placeholder.type')
          "
          :popper-class="b('type-select-wrapper')"
        >
          <el-option
            v-for="item of typeList"
            :key="item.id"
            :label="item.controlName"
            :value="item.id"
          >
            <em
              v-if="item.icon"
              :class="[item.icon, 'option-icon']"
            />
            <span>{{ item.controlName }}</span>
          </el-option>
        </el-select>
      </el-form-item>

      <el-form-item
        prop="fieldName"
        :label="$t('project.issueType.customFieldDialog.form.label.name')"
      >
        <el-input
          v-model="vo.fieldName"
          v-trim="vo.fieldName"
          v-el-input-auto-padding
          :type="$inputLimit.fieldName > $inputMaxLength ? 'textarea' : 'text'"
          :maxlength="$inputLimit.fieldName"
          show-word-limit
          data-auto-test-area="zk-custom-filed-name"
          :field-type-id="vo.formControlId"
          :disabled="isView"
          :placeholder="
            $t('project.issueType.customFieldDialog.form.placeholder.name')
          "
        />
      </el-form-item>

      <div
        v-if="showOption"
        :class="b('option-wrapper')"
        class="clear-mb-0"
      >
        <div class="el-form-item is-required clear-mb-0">
          <label class="el-form-item__label">
            {{ $t("setting.Option") }}
          </label>
        </div>
        <OptionsInput
          v-if="showOption"
          ref="optionsInput"
          v-model="vo.optionList"
          :is-checkbox-option="isCheckboxOption"
          :is-radio-option="isRadioOption"
          :sigle="!isSingleOption"
          :calculate-value-flag="isEvaluated"
          :is-update="isUpdate"
          :is-cancel="canDelete"
          :default-radio-check="radioCheck"
          :is-labels="isLabels"
          @canNotDelete="canNotDelete"
          @removeOption="removeOption"
          @addOption="evaluationAddOption"
          @checkCreated="checkCreated"
          @update:radioCheck="handleRadioClick"
          @update:calculateValueFlag="handleCalculateValueFlag"
          @blur-null="blurToNull"
        />
        <el-link
          class="add-option-button"
          type="primary"
          :underline="false"
          @click="handlerBtnAdd"
          @mousedown.native.prevent
        >
          + {{ $t("button.addTo") }}
        </el-link>
      </div>

      <el-form-item
        v-if="showFormula"
        :label="
          $t('project.issueType.customFieldDialog.form.label.setCalcMethod')
        "
        prop="expression"
      >
        <el-input
          v-if="isHistoryFormula"
          :value="formulaExpressionText"
          disabled
        />
        <FormulaForm
          v-else
          ref="formula-form"
          v-model="vo.expressionHtml"
          :expression="vo.expression"
          :options="formulaOptions"
          :param-list="formulaParamList"
          :disabled="isUpdate"
          :project-id="projectId"
        />
      </el-form-item>

      <el-form-item
        v-if="showFormula"
        prop="expressionReturnType"
        :class="b('return-type-item')"
      >
        <div :class="b('custom-label')">
          <label class="el-form-item__label">
            {{ $t("setting.formula.backType") }}
          </label>
          <el-tooltip
            v-if="showExpressionTips"
            :content="
              $t('project.issueType.customFieldDialog.form.formula.backInit')
            "
            placement="right"
          >
            <em class="iconinfo zkicon" />
          </el-tooltip>
        </div>
        <el-select
          v-model="vo.expressionReturnType"
          :placeholder="
            $t('project.issueType.customFieldDialog.form.label.backType')
          "
          :class="b('field-back-type')"
          :disabled="isUpdate"
        >
          <el-option
            v-for="item in formulaFieldBackType"
            :key="item.key"
            :label="item.value"
            :value="item.key"
          />
        </el-select>
      </el-form-item>
      <!--text是否显示autoComplete -->
      <el-form-item
        v-if="isText"
        prop="autoComplete"
      >
        <template #label>
          {{ $t('project.issueType.customFieldDialog.form.label.autoComplete') }}
          <el-tooltip
            :content="$t('project.issueType.customFieldDialog.form.autoCompletePopover')"
            placement="top"
          >
            <em :class="['zkicon', 'iconinfo', 'zk-tips-icon', 'ignore-drag']" />
          </el-tooltip>
        </template>

        <el-input
          v-model="vo.autoComplete"
          v-trim="vo.autoComplete"
          v-el-input-auto-padding
          type="text"
          maxlength="30"
          show-word-limit
          :disabled="isView"
          :placeholder="$t('integration.step1.form.idPlaceholder')"
        />
      </el-form-item>
   
      <!-- 小数点精度 -->
      <el-form-item
        v-if="showNumberPrecision"
        :label="$t('project.issueType.customFieldDialog.form.label.precision')"
        prop="numberPrecision"
        class="is-required"
        :rules="{
          required: true,
          message: $t(
            'project.issueType.customFieldDialog.form.placeholder.precision'
          ),
          trigger: 'change',
        }"
      >
        <el-select
          v-model="vo.numberPrecision"
          style="width: 100%"
          data-field-code="zk-number-precision"
          :disabled="isView"
          :placeholder="
            $t('project.issueType.customFieldDialog.form.placeholder.precision')
          "
        >
          <el-option
            v-for="item in numberPrecisionOptions"
            v-show="!item.hidden"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          />
        </el-select>
      </el-form-item>
      <!-- 数值范围 -->
      <el-form-item
        v-if="showNumberRange"
        prop="numberCustomFieldExtend"
        :label="$t('setting.numberRange')"
      >
        <div :class="b('number-range')">
          <NumberInput
            v-model="vo.numberCustomFieldExtend.min"
            data-auto-test-area="min-number"
            :precision="numberPrecision"
            :placeholder="$t('setting.numberMin')"
            @blur="onNumRangeBlur"
          />
          <NumberInput
            v-model="vo.numberCustomFieldExtend.max"
            data-auto-test-area="max-number"
            :precision="numberPrecision"
            :placeholder="$t('setting.max')"
            @blur="onNumRangeBlur"
          />
        </div>
        <div
          v-if="numberBlurTips"
          :class="b('number-blur-tips')"
        >
          {{ numberBlurTips }}
        </div>
      </el-form-item>

      <!-- 人员字段类型 控件-->
      <PersonnelFileControl
        v-if="showPersonnel"
        :is-update="isUpdate"
        :project-id="projectId"
        :multiple="vo.memberInfo.multipleChoice"
        :personnel-scope="vo.memberInfo.selectedMemberList"
        :default-value="vo.defaultValue"
        @personnel-scope-change="(event) => onMemberChange(event, 'selectedMemberList')"
        @multiple-change="(event) => onMemberChange(event, 'multipleChoice')"
        @default-personnel-change="(event) => onMemberChange(event, 'defaultValue')"
      />

      <!-- 富文本 -->
      <div v-if="isTextDefaultValue">
        <el-form-item
          :label="$t('issue.rich.default.label')"
        >
          <el-input
            v-model="vo.defaultValue"
            type="textarea"
            show-word-limit
            :rows="6"
            :maxlength="$inputLimit.richDefaultText"
          />
        </el-form-item>
      </div>

      <el-form-item
        prop="tips"
        :label="$t('project.issueType.customFieldDialog.form.label.desc')"
        :class="b('field-description')"
      >
        <el-input
          v-model="vo.tips"
          v-el-input-auto-padding
          type="textarea"
          show-word-limit
          data-auto-test-area="zk-custom-filed-tips"
          :row="4"
          :placeholder="filedDescPlaceholder"
          :maxlength="$inputLimit.fieldDesc"
          :disabled="isView"
          :field-type-id="vo.formControlId"
        />
      </el-form-item>
    </el-form>

    <div
      slot="footer"
      :class="b('footer')"
    >
      <el-button
        :type="isView ? 'primary' : null"
        @click="cancel()"
      >
        {{ isView ? $t("button.close") : $t("button.cancel") }}
      </el-button>
      <el-button
        v-if="!isView"
        type="primary"
        :loading="saveLoading.loading"
        :disabled="!isSubmit"
        @click="saveLoading.fn"
      >
        {{ isUpdate ? $t("button.save") : $t("button.newer") }}
      </el-button>
    </div>
  </el-dialog>
</template>

<script>
import {
  excludeComponentProps,
  getComponentProps,
  inheritComponentListener,
  getDialogBodyMaxHeight,
  validateForm
} from '@zk/framework-vue';
import { Dialog } from 'zk-ui';
import theme from '@zk/theme/lib/variables.scss';
import _, { words, cloneDeep, isNull, isNil, isEmpty, isArray, isEqual } from 'lodash';
import {
  addField,
  formulaBackType,
  formulaExpressCondition,
  loadFieldInfo,
  loadNewFieldType,
  updateField,
  getUserGroupDepartment,
  numberCheckExpression
} from 'common-module/src/api/field';
import { createLoadingEvent } from '@zk/framework-vue';
import FormulaForm from './FormulaForm';
import PersonnelFileControl from './PersonnelFileControl';
import OptionsInput from 'common-module/src/components/OptionsInput';
import { getRandomColor } from 'common-module/src/util/randomColor';

const colorPicker = getRandomColor();
const TYPE_ICON = {
  formula: 'zkicon icongongshi',
  text: 'zkicon iconwenben',
  integer: 'zkicon iconzhengshu',
  decimal: 'zkicon iconxiaoshu',
  date: 'zkicon iconriqi1',
  datetime: 'zkicon iconshijianriqi',
  'rich-text': 'zkicon iconfuwenben1',
  'long-text': 'zkicon iconfuwenben',
  radio: 'zkicon icondanxuan',
  'single-select': 'zkicon iconxialadanxuan',
  select: 'zkicon iconxialaduoxuan',
  link: 'zkicon iconlianjie',
  labels: 'zkicon iconbiaoqian',
  'progress-bar': 'zkicon iconjindutiao',
  member: 'zkicon iconrenyuan'
};

const FORMULA_PERCENTAGE_TYPE = ['percentage_bar', 'percentage_number'];
const props = {
  id: {
    type: [Number, String],
    default: null
  },
  existNames: {
    type: Array,
    default: () => []
  },
  currentProjectId: {
    type: Number,
    debugger: null
  },
  isView: {
    type: Boolean,
    default: false
  },
  allAssociate: {
    type: Array,
    default: () => []
  },
  showExpressionTips: {
    type: Boolean,
    default: true
  }
};
export default {
  name: 'CustomFieldDialog',
  components: {
    FormulaForm,
    OptionsInput,
    PersonnelFileControl
  },
  props: {
    ...getComponentProps(Dialog),
    ...props
  },
  data() {
    return {
      bemNS: theme.bemNS,
      show: this.visible,
      vo: {
        formControlId: null,
        fieldName: null,
        autoComplete: null,
        tips: null,
        optionList: [],
        expressionReturnType: null, // 公式结果返回类型
        expression: null, // 表达式
        expressionHtml: null, // 表达式html
        numberPrecision: null,
        memberInfo: {
          multipleChoice: false,
          selectedMemberList: []
        },
        defaultValue: '',
        numberCustomFieldExtend: {
          min: null,
          max: null
        }
      },
      oldInfo: {},
      typeList: [],
      saveLoading: createLoadingEvent(this.save),
      // 公式字段下拉列表参数
      formulaOptions: {
        // fieldBackType: [],
        customFieldVOList: [],
        operatorVoList: [],
        unitVoList: [],
        functionList: []
      },
      formulaFieldBackType: [],
      formulaParamList: [], // 公式函数参数列表
      radioCheck: null,
      // 成员
      memberList: [],
      memberSelectListVo: [],
      defaultValueArr: null,
      loading: false,
      numberBlurTips: null,
      isEvaluated: false, //判断该字段是否开启赋分值,
      filedId: null,
      form: null,
      calculateValueFlag: null, //是否开启赋分值
      operate: 'blur'
    };
  },
  computed: {
    dialogTitle() {
      if (this.isView) {
        return this.$t('project.issueType.customFieldDialog.title.view');
      }
      return this.isUpdate
        ? this.$t('project.issueType.customFieldDialog.title.edit')
        : this.$t('project.issueType.customFieldDialog.title.add');
    },
    dialogOption() {
      return {
        width: '550px',
        top: '50px',
        title: this.dialogTitle,
        ...excludeComponentProps(this, props)
      };
    },
    listeners() {
      return inheritComponentListener(Dialog, this, 'dialog-');
    },
    isUpdate() {
      return !!this.id;
    },
    showOption() {
      return ['radio', 'select', 'single-select', 'labels'].includes(
        this.fieldTypeControl
      );
    },
    isSingleOption() {
      return (
        this.fieldTypeControl === 'radio' ||
        this.fieldTypeControl === 'single-select'
      );
    },
    isText() {
      return this.fieldTypeControl === 'text';
    },
    isRadioOption() {
      return ['radio', 'single-select'].includes(this.fieldTypeControl);
    },
    isCheckboxOption() {
      return this.fieldTypeControl === 'select';
    },
    isPercentage() {
      return (
        this.showFormula &&
        FORMULA_PERCENTAGE_TYPE.includes(this.vo.expressionReturnType)
      );
    },
    showFormula() {
      return this.fieldTypeControl === 'formula';
    },
    showFormulaPrecision() {
      return (
        this.showFormula &&
        (this.isPercentage || this.vo.expressionReturnType === 'decimal')
      );
    },
    showNumberPrecision() {
      return this.isDecimal || this.showFormulaPrecision;
    },
    showNumberRange() {
      return ['decimal', 'integer'].some((s) => this.fieldTypeControl === s);
    },
    isTextDefaultValue() {
      return this.fieldTypeControl === 'rich-text' || this.fieldTypeControl === 'long-text';
    },
    isInteger() {
      return this.fieldTypeControl === 'integer';
    },
    isDecimal() {
      return this.fieldTypeControl === 'decimal';
    },
    numberPrecision() {
      if (this.showNumberRange && !this.isInteger) {
        return this.vo.numberPrecision || 2;
      }
      return 0;
    },
    rules() {
      if (!this.$t) {
        return {};
      }
      return {
        formControlId: [
          {
            required: true,
            trigger: 'none',
            message: this.$t(
              'project.issueType.customFieldDialog.form.placeholder.type'
            )
          }
        ],
        fieldName: [
          {
            required: true,
            message: this.$t(
              'project.issueType.customFieldDialog.form.placeholder.name'
            )
          },
          { max: this.$inputLimit.fieldName, message: ' ', trigger: 'blur' },
          {
            validator: (rule, value, callback) => {
              if (
                value &&
                value !== this.oldInfo.fieldName &&
                this.existNames.includes(value)
              ) {
                return callback(
                  new Error(
                    this.$t(
                      'project.issueType.customFieldDialog.form.errorMsg.existName'
                    )
                  )
                );
              }
              callback();
            }
          }
        ],
        expressionReturnType: [
          {
            required: true,
            message: this.$t(
              'project.issueType.customFieldDialog.form.errorMsg.backType'
            )
          }
        ],
        expression: [
          // { required: true, message: this.$t('project.issueType.customFieldDialog.form.errorMsg.expression'), trigger: 'change' }
          {
            validator: (rule, value, callback) => {
              const val = value || this.vo.expressionHtml;
              !val ? callback(new Error()) : callback();
            },
            message: this.$t(
              'project.issueType.customFieldDialog.form.errorMsg.expression'
            ),
            trigger: 'change'
          }
        ],
        tips: [
          { max: this.$inputLimit.fieldDesc, message: ' ', trigger: 'blur' }
        ],
        'memberInfo.selectedMemberList': [
          {
            validator: (rule, value, callback) => {
              value?.length < 1 ? callback(new Error()) : callback();
            },
            required: this.showPersonnel,
            message: this.$t('setting.memberFile.error.selectRange'),
            trigger: 'change'
          }
        ],
        numberCustomFieldExtend: [
          {
            validator: (rule, value, callback) => {
              const { min, max } = value || {};
              if (!isNil(min) && !isNil(max)) {
                min > max ? callback(new Error()) : callback();
              }
              callback();
            },
            message: this.$t('setting.numberRang.error'),
            trigger: 'blur'
          },
          {
            validator: (rule, value, callback) => {
              const isOver =
                this.checkNumRangOverPrecision(value.min) ||
                this.checkNumRangOverPrecision(value.max);
              isOver ? callback(new Error()) : callback();
            },
            message: this.$t('setting.numberRang.error1'),
            trigger: 'blur'
          }
        ]
      };
    },
    fieldType() {
      return this.typeList.find((item) => item.id === this.vo.formControlId);
    },
    fieldTypeControl() {
      return this.fieldType?.controlCode;
    },
    // 是否可以点击提交
    isSubmit() {
      if (!this.showFormula) {
        return true;
      }
      const rules = JSON.parse(JSON.stringify(this.rules));
      console.log('rules', rules);
      for (const key in rules) {
        const rs = Array.isArray(rules[key]) ? rules[key] : [rules[key]];
        console.log('rs', rs);
        if (!rs.some((r) => r.required)) {
          continue;
        }
        if (!this.vo[key]) {
          return false;
        }
      }
      return true;
    },
    projectId() {
      return this.currentProjectId || this.$store.state.app.currentProject;
    },
    findLabelAll() {
      const { customFieldVOList, unitVoList } = this.formulaOptions;
      return [...customFieldVOList, ...unitVoList];
    },
    isHistoryFormula() {
      return this.isUpdate && !this.vo.expressionHtml;
    },
    // 解析公式为label形式
    formulaExpressionText() {
      let result = this.vo.expression;
      const textArray = _.words(result, /[^+\-*/()（）\s]+/g);
      let startIndex = 0;
      textArray.forEach((item) => {
        //数字特殊处理
        item = this.segmentation(item);
        // 剩余的需要比较的字符串，已经替换过的不列入比较范围
        let nextStr = result.slice(startIndex);
        const element = _.find(this.findLabelAll, { key: item });
        if (element) {
          result =
            result.slice(0, startIndex) +
            _.replace(nextStr, item, element?.value);
          nextStr = result.slice(startIndex);
          const newIndex = nextStr.indexOf(element?.value);
          if (newIndex > -1) {
            startIndex += newIndex + element?.value?.length;
          }
        }
      });
      return result;
    },
    showPersonnel() {
      return this.fieldTypeControl === 'member';
    },
    numberPrecisionOptions() {
      return [
        { label: '1', value: 0, hidden: !this.isPercentage },
        { label: '1.0', value: 1, hidden: false },
        { label: '1.00', value: 2, hidden: false },
        { label: '1.000', value: 3, hidden: false },
        { label: '1.0000', value: 4, hidden: this.isPercentage }
      ];
    },
    formulaAssociate() {
      //该字段所有被依赖的数组集合
      return this.allAssociate.filter((item) => item.id === this.filedId);
    },
    formulaFieldName() {
      //返回this.formulaAssociate中每一项的fieldName并拼接为字符串
      return this.formulaAssociate[0].formulaInfo
        .map((item) => item.customFieldName)
        .join(',');
    },
    canDelete() {
      //如果this.formulaAssociate为空，说明没有关联字段，可以删除
      return isEmpty(this.formulaAssociate);
    },
    filedDescPlaceholder() {
      return this.isView
        ? this.$t(
          'project.issueType.customFieldDialog.form.placeholder.emptyDesc'
        )
        : this.$t('project.issueType.customFieldDialog.form.placeholder.desc');
    },
    isLabels() {
      return this.fieldTypeControl === 'labels';
    }
  },
  watch: {
    show(value) {
      this.$emit('update:visible', value);
    },
    visible(value) {
      this.show = value;
    },
    showFormula: {
      immediate: true,
      handler(value) {
        value && this.formulaInit();
      }
    },
    'vo.formControlId': {
      handler() {
        this.$nextTick(() => this.$refs.form.clearValidate());
      }
    },
    showOption: {
      immediate: true,
      handler(/* single */) {
        this.$nextTick(() => {
          if (
            !this.isUpdate
            && !(this.vo.optionList.length === 1 && !this.vo.optionList[0]?.optionValue)
          ) {
            this.vo.optionList.push({
              optionValue: null,
              isDefault: false,
              radioValue: new Date().getTime() + Math.random() * 10,
              calculateValue: this.isEvaluated ? Number(0) : null,
              color: this.isLabels ? this.getColor() : undefined
            });
          }
        });
      }
    },
    isEvaluated: {
      handler(val) {
        if (!val) {
          //关闭赋分值
          //如果是更新操作，并且来自于子组件，且一开始是开启赋分值状态。
          if (
            this.isUpdate &&
            this.from === 'options' &&
            this.calculateValueFlag &&
            this.canDelete
          ) {
            this.vo.optionList.forEach((item) => {
              item.calculateValue = null;
            });
          }
        } else if (this.from === 'options') {
          this.vo.optionList.forEach((item) => {
            item.calculateValue = Number(0);
          });
        }
      }
    }
  },
  created() {
    this.loadTypes();
  },
  methods: {
    getColor() {
      return colorPicker();
    },
    async loadTypes() {
      const list = await loadNewFieldType();
      this.typeList = list.map((item) => ({
        ...item,
        icon: TYPE_ICON[item.controlCode]
      }));
    },
    async onOpen() {
      this.$nextTick(() => this.$refs.form.clearValidate());
      const getExpressionHtml = (value) => {
        if (!value) {
          return null;
        }
        // const { expressionHtml } = JSON.parse(value) || {};
        const { expressionHtml } = value || {};
        return expressionHtml;
      };

      if (this.id && this.isUpdate) {
        try {
          this.loading = true;
          const info = await loadFieldInfo(this.id);
          this.oldInfo = info;
          this.vo.formControlId = info.formControl.id;
          this.vo.fieldName = info.fieldName;
          this.vo.optionList = this.calculateValueToNumber(info.options) || [];
          this.calculateValueFlag = info.calculateValueFlag;
          this.isEvaluated = !!info.calculateValueFlag;
          this.vo.tips = info.tips;
          this.vo.expression = info.expression;
          this.vo.expressionHtml = getExpressionHtml(
            info.formulaCustomFieldExtend /* || FORMULA_MOCK */
          );
          this.vo.formulaCustomFieldExtend = info.formulaCustomFieldExtend;
          this.vo.expressionReturnType = info.expressionReturnType;
          this.vo.numberPrecision = info.numberPrecision;
          this.vo.numberCustomFieldExtend = {
            min: null,
            max: null,
            ...info.numberCustomFieldExtend
          };
          this.vo.autoComplete = info.autoComplete;
          this.filedId = info.id;
          if (this.isRadioOption) {
            this.radioCheck = this.vo.optionList?.find(
              (item) => item.isDefault
            )?.id;
          }
          const { multipleChoice, selectedMemberList } = info.memberInfo || {};
          this.vo.memberInfo = { multipleChoice, selectedMemberList };
          this.vo.defaultValue = info.defaultValue;
        } finally {
          this.loading = false;
        }
      }
    },
    calculateValueToNumber(arr) {
      if (this.showOption && isArray(arr)) {
        return arr.map((item) => {
          return {
            ...item,
            calculateValue: isNil(item.calculateValue) ? item.calculateValue : Number(item.calculateValue)
          };
        });
      }
      return arr;
    },
    // 字段名包含数字处理
    segmentation(str) {
      const hasNum = !!str.match(/\d/g);
      if (!hasNum) {
        return str;
      }

      const numStr = words(str, /[^\d]+/g);
      if (numStr?.length > 1) {
        return str;
      }

      const unitOption = this.formulaOptions?.unitVoList;
      const res = unitOption.find((item) => item.key === numStr[0]);
      return res ? numStr[0] : str;
    },
    /**
     * 隐藏弹窗
     * @param save 如果不为保存，则触发cancel事件
     */
    cancel(save = false) {
      this.show = false;
      this.$refs.form.resetFields();
      //关闭窗口，form-item会报错这里特殊处理一下
      this.$nextTick(() => {
        this.vo.optionList = [];
      });
      this.vo.expressionReturnType = null;
      this.vo.expression = null;
      this.vo.expressionHtml = null;
      this.vo.tips = null;
      this.vo.numberPrecision = null;
      this.vo.numberCustomFieldExtend = { min: null, max: null };
      this.numberBlurTips = null;
      this.oldInfo = {};
      this.vo.autoComplete = null;
      this.$refs['formula-form']?.clear();
      if (!save) {
        this.$emit('cancel');
      }
      this.clearMember();
      this.isEvaluated = false;
      this.filedId = null;
      this.from = null;
      this.$refs.optionsInput?.clear();
    },
    clearMember() {
      this.vo.memberInfo = {
        multipleChoice: false,
        selectedMemberList: []
      };
      this.vo.defaultValue = '';
      this.memberList = [];
      this.memberSelectListVo = [];
      this.defaultValueArr = null;
      // this.isFilterMembers = false;
      this.$refs.MemberFileGroupSelect?.clearLabel();
    },
    async save() {
      await validateForm(this.$refs.form);
      const param = {
        ...this.vo,
        projectId: this.projectId
      };

      if (this.fieldTypeControl === 'rich-text' && this.vo.defaultValue) {
        param.defaultValue = this.vo.defaultValue;
      }
      // 这个字段没用表单的验证
      if (this.showOption && !this.vo.optionList?.length) {
        return;
      }

      // 校验公式合法性
      if (this.showFormula && !this.isUpdate) {
        const expression = this.$refs['formula-form'].getAnalyzeFormula();
        const functionModules = this.$refs['formula-form'].getAnalyzeFields();
        const isLegal = await this.$refs['formula-form'].checkExpress(
          expression,
          functionModules
        );
        if (!isLegal) {
          return;
        }
        param.formulaCustomFieldExtend = {
          expression,
          functionModules,
          expressionHtml: this.vo.expressionHtml
            .replace(/\s+|\r|\n/g, ' ')
            .trim()
        };
        param.expression = expression;
      }

      const getOptionIsDefault = (item) => {
        if (this.isRadioOption) {
          if (!this.radioCheck) {
            return false;
          }
          return (
            item.radioValue === this.radioCheck || item.id === this.radioCheck
          );
        }
        return !!item.isDefault;
      };

      if (this.showOption) {
        delete param.optionList;
        param[this.isUpdate ? 'options' : 'optionValues'] =
          this.vo.optionList.map((item) => {
            return !this.isSingleOption
              ? {
                optionValue: item.optionValue,
                isDefault: getOptionIsDefault(item),
                optionId: this.isUpdate ? item.id : undefined,
                color: item.color
              }
              : {
                optionValue: item.optionValue,
                isDefault: getOptionIsDefault(item),
                calculateValue: item.calculateValue,
                optionId: this.isUpdate ? item.id : undefined,
                color: item.color
              };
          });
      }

      let res;
      if (this.isUpdate) {
        res = await updateField({
          ...param,
          id: this.id
        });
        this.$message.success(
          this.$t('project.issueType.customFieldDialog.form.updateSuccess', [
            this.vo.fieldName
          ])
        );
      } else {
        res = await addField({
          ...param
        });
        try {
          const find = this.typeList.find(
            (item) => item.id === param.formControlId
          );
          this.$track.send(
            'IssueType_newFieldAdd',
            { typeName: find?.controlName, fieldCode: find?.controlCode, default_value: !!this.vo.defaultValue },
            true
          );
          this.$track.send(
            // eslint-disable-next-line spellcheck/spell-checker
            'Issue_Addfiled',
            { source: 'add', type: find?.controlName },
            true
          );
          const formulaUsedField = this.$refs['formula-form']?.getUsedFields() || [];
          const usedFields = new Set(formulaUsedField.filter(k => ['estimateLabour', 'remainingLabour', 'actualLabour', 'estimatePoint', 'labourRecord'].includes(k)));
          // eslint-disable-next-line spellcheck/spell-checker
          this.$track.send('Issue_Formulafields', {
            Workload_field: [...usedFields].join(',')
          }, true);
        } catch (_) {
          // eslint-disable-next-line no-empty
        }
        this.$message.success(
          this.$t('project.issueType.customFieldDialog.form.addSuccess', [
            this.vo.fieldName
          ])
        );
      }

      const { fieldType } = this;
      const data = cloneDeep(this.vo);
      this.cancel(true);
      this.$emit('save', res, data, fieldType);
    },
    addOption() {
      this.operate = 'blur';
      this.evaluationAddOption('btn');
    },
    evaluationAddOption(type = 'options') {
      if (type === 'options') {
        this.operate = 'enter';
      }
      //版本较低的浏览器无法使用at操作符
      const lastOption = this.vo.optionList.at(-1);
      if (lastOption && !_.isEmpty(lastOption.optionValue)) {
        this.vo.optionList.push({
          optionValue: null,
          isDefault: false,
          radioValue: new Date().getTime() + Math.random() * 10,
          calculateValue: this.isEvaluated ? 0 : null,
          color: this.isLabels ? this.getColor() : undefined
        });
        this.operate = 'blur';
      } else {
        this.$refs.optionsInput?.focusInput();
      }
    },
    checkCreated(id) {
      if (this.operate === 'blur') {
        //通过id去找到该选项，判断该选项的optionVlaue是否为空，如果为空，则删除
        const index = this.vo.optionList.findIndex(
          (item) => item.radioValue === id
        );
        console.log('id,index', id, index);
        if (index > -1) {
          if (
            !this.vo.optionList[index].optionValue &&
            this.vo.optionList.length > 1
          ) {
            this.$nextTick(() => {
              this.vo.optionList.splice(index, 1);
            });
          }
        }
      }
      this.operate = 'blur';
    },
    handlerBtnAdd() {
      this.$nextTick(() => this.$refs.optionsInput?.focusInput());
      this.addOption();
    },
    removeOption(index) {
      if (this.vo.optionList.length > 1 || !this.isSingleOption) {
        this.vo.optionList.splice(index, 1);
      }
    },
    /** 公式字段下拉列表初始化 */
    async formulaInit() {
      this.formulaFieldBackType = await formulaBackType();
      const {
        customFieldVOList = [],
        operatorVoList = [],
        unitVoList = [],
        profileFormulaFunctionVO: { functionList, paramList } = {}
      } = await formulaExpressCondition({ projectId: this.projectId });

      this.formulaOptions = {
        customFieldVOList: this.formatOptions(
          customFieldVOList,
          'fieldCode',
          'fieldName'
        ),
        operatorVoList: this.formatOptions(operatorVoList, 'operator', 'name'),
        unitVoList,
        functionList
      };
      this.formulaParamList = paramList;
    },
    formatOptions(value, keyVal, labelVal) {
      if (!value.length) {
        return [];
      }
      return value.map((item) => {
        return { ...item, key: item[keyVal], value: item[labelVal] };
      });
    },
    /** 公式表达式改变时 */
    formulaExpression(val) {
      this.vo.expression = val;
    },
    getDialogBodyMaxHeight() {
      return getDialogBodyMaxHeight(this.$el);
    },
    handleUpdateRadio(id) {
      this.radioCheck = id;
    },
    handleRadioClick(id) {
      this.radioCheck = this.radioCheck === id ? null : id;
      // 点击完成失去焦点，解决有蓝色阴影
      // this.$refs.radioCheck[index]?.$el.blur();
    },
    async loadMemberFileInit() {
      const res = await getUserGroupDepartment({ projectId: this.projectId });
      this.memberList = res;
    },
    onMemberChange(event, key) {
      console.log('🚀 ~ file: index.vue:1323 ~ onMemberChange ~ event, key:', event, key);
      if (key === 'defaultValue') {
        this.vo.defaultValue = event;
        return;
      }
      this.vo.memberInfo[key] = event;
    },
    async onNumRangeBlur() {
      const { min, max } = this.vo.numberCustomFieldExtend;
      const _isNull = isNull(min) && isNull(max);
      if (!this.isUpdate || _isNull) {
        this.numberBlurTips = null;
        return;
      }
      const res = await numberCheckExpression({
        customFieldId: this.id,
        min,
        max
      });
      this.numberBlurTips = res.isLegal
        ? null
        : this.$tc('setting.numberRang.init', res.illegalNumber, {
          num: res.illegalNumber,
          total: res.totalNumber
        });
    },
    checkNumRangOverPrecision(val) {
      if (!this.numberPrecision || !val || this.isInteger) {
        return;
      }
      const end = val.toString().split('.') || [];
      return (end[1]?.length || 0) > this.numberPrecision;
    },
    onStart() {
      document.documentElement.classList.add('draggable-cursor-grabbing');
    },
    onEnd() {
      document.documentElement.classList.remove('draggable-cursor-grabbing');
    },
    canNotDelete(status) {
      if (!status) {
        const msg = this.$t(
          'project.issueType.customFieldDialog.optionAssignment.removeMsg',
          [this.vo.fieldName, this.formulaFieldName]
        );
        this.$message({
          type: 'error',
          dangerouslyUseHTMLString: true,
          message: msg
        });
      }
    },
    handleCalculateValueFlag(evaluated, type) {
      this.isEvaluated = evaluated;
      this.from = type;
    },
    blurToNull(){
      this.vo.optionList.forEach((item) => {
        const isNegative = isEqual(item.calculateValue, -0) || isEqual(item.calculateValue, -0.);
        const isNull = item.calculateValue === '' || _.isNil(item.calculateValue);
        if (isNull) {
          item.calculateValue = 0;
        }
        if (isNegative){
          item.calculateValue = '0';
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
@import "~@zk/theme/lib/mixins.scss";
$placeholder: #ccc;

@include b(custom-field-dialog) {
  @include e(type-select-wrapper) {
    @include icon {
      color: var(--purpleGray-7);
      margin-right: 8px;
    }
  }
  @include e(option-item) {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    margin-bottom: var(--p-default);
    .el-input {
      width: auto;
      flex: 1;
    }
    .el-button {
      width: 26px;
      height: 26px;
      margin-left: 8px;
    }
    .iconicon_yidong {
      cursor: grab;
      font-size: 10px;
      padding-left: 6px;
    }
  }
  ::v-deep .el-dialog__footer {
    display: flex;
    justify-content: flex-end;
    padding: 22px var(--m-oversize);
  }
  ::v-deep.el-form-item__label {
    padding-bottom: 5px;
    line-height: 1.5;
  }
  ::v-deep.el-form .el-select {
    width: 100%;
    &,
    .el-plain-selected {
      max-width: 100%;
    }

    .el-plain-selected.is-disabled .el-plain-selected__caret{
      cursor: not-allowed;
      pointer-events:none;
    }
  }
  @include e(custom-label) {
    line-height: 1;
    ::v-deep .el-form-item__label::before {
      content: "*";
      color: var(--danger-color);
    }
  }
  @include e(field-description) {
    margin-bottom: 0px !important;
    overflow: hidden;
  }
  @include e(field-back-type) {
    width: 100%;
  }
  @include e(return-type-item) {
    .el-tooltip {
      line-height: 1.2;
      margin-left: 6px;
    }
  }
  @include e(footer) {
    display: flex;
    align-items: center;
    justify-content: flex-end;
  }
  @include e(warning-tip) {
    color: var(--danger-color);
    font-size: var(--size-font-9);
  }
  @include e(check) {
    display: flex;
    margin: 0 0 0 10px;
  }
  @include e(people-select) {
    ::v-deep .zk-people-select__placeholder {
      padding-left: 16px;
    }
  }
  @include e(number-range) {
    display: flex;
    width: 100%;
    .zk-number-input + .zk-number-input {
      margin-left: 20px;
    }
  }
  @include e(number-blur-tips) {
    color: var(--primary-color);
  }
  @include e(option-wrapper) {
    margin-bottom: 22px;
    ::v-deep .el-form-item {
      margin-bottom: 8px;
      &.is-error {
        margin-bottom: 20px !important;
      }
    }
  }
  ::v-deep {
    div .el-form-item:nth-child(2) {
      margin-left: 0px;
    }
  }
  ::v-deep {
    div .el-form-item:last-child {
      margin-bottom: 20px;
    }
  }
  .add-option-button {
    font-size: var(--size-font-7);
    color: var(--primary-color);
    height: 26px;
    text-align: center;
    line-height: 24px;
    cursor: pointer;
    margin-bottom: 20px;
  }
  .clear-mb-0 {
    margin-bottom: 0;
  }
}
</style>
<style lang="scss">
/* 这里临时做个处理，后面再组件内加popper-class入口 */
.zk-people-select__select-plain {
  .zk-group-select__g-box .el-select-panel__item {
    padding-left: 40px;
  }
}
</style>
